import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Badge } from "@/lib/ui";
import { Mail, RefreshCw } from "lucide-react";

export default function AdminEmailQueue() {
  const [q, setQ] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/email-queue").then((r) => setQ(r.data)).catch(() => {});
  useEffect(() => { load(); const i = setInterval(load, 15000); return () => clearInterval(i); }, []);

  const retry = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/email-queue/retry"); toast.success(`Retried ${data.tried}, sent ${data.sent}`); load(); }
    catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (!q) return null;
  return (
    <section data-testid="email-queue-panel" className="bg-white border border-[#E2D9CE] rounded-2xl p-5">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2"><Mail className="w-6 h-6 text-[#D96B43]" /><h2 className="text-xl font-display font-bold text-slate-900">Email queue</h2></div>
        <div className="flex items-center gap-3">
          <Badge color="gold" testid="email-queue-pending">{q.pending} pending</Badge>
          <Badge color={q.failed ? "red" : "slate"} testid="email-queue-failed">{q.failed} failed</Badge>
          <Badge color="green" testid="email-queue-sent">{q.sent_24h} sent today</Badge>
          <button data-testid="email-queue-retry-btn" onClick={retry} disabled={busy} className="flex items-center gap-2 bg-[#2E7D6B] hover:bg-[#256658] disabled:opacity-60 text-white font-semibold px-4 min-h-[44px] rounded-xl"><RefreshCw className="w-4 h-4" /> Retry now</button>
        </div>
      </div>
      {q.recent.length === 0 ? <p className="text-slate-500">Nothing waiting — all emails delivered.</p> : (
        <ul className="divide-y divide-[#E2D9CE] text-sm">
          {q.recent.map((e) => (
            <li key={e.id} data-testid={`email-queue-item-${e.id}`} className="py-2 flex flex-wrap items-center justify-between gap-2">
              <span className="text-slate-800"><b>{e.subject}</b> → {e.to} <span className="text-slate-500">({e.kind}, priority {e.priority})</span></span>
              <span className="flex items-center gap-2"><Badge color={e.status === "failed" ? "red" : "gold"}>{e.status} · {e.attempts}/5</Badge>{e.last_error && <span className="text-slate-500 truncate max-w-xs" title={e.last_error}>{e.last_error}</span>}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
